var React = require('react');

function Input (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"points":"70.7,93.6 66.5,89.4 81.5,74.4 66.5,59.4 70.7,55.2 90,74.4 \t","key":0}),React.createElement("rect",{"x":"35","y":"72","width":"51","height":"6","key":1}),React.createElement("polygon",{"points":"108,107 45,107 45,87 51,87 51,101 102,101 102,50 51,50 51,63 45,63 45,44 108,44 \t","key":2})])]);
}

Input.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 150 150","style":{"enableBackground":"new 0 0 150 150"},"xmlSpace":"preserve"};

module.exports = Input;

Input.default = Input;
